// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iIgH","input":"styles_input__3Kg5w"};